// src/api/adminRecordingsApi.js
import api from './axios';

export const getRecordingConfig  = ()      => api.get('/recordings/admin/config');
export const updateRecordingConfig = (cfg) => api.patch('/recordings/admin/config', cfg);
export const listRecordings = (params={})  => api.get('/admin/recordings', { params });
